import * as React from 'react';
import { SVGProps } from 'react';

const FileIconRarSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12H5v13h14V12h-5v1h4v11H6V12Zm1 0h3v1h2v1h-2v1h2v1h-2v2h1v4H8v-4h1v-1H7v-1h2v-1H7v-1h2v-1H7v-1Zm3 7H9v2h1v-2Z"
      fill="#fff"
    />
    <path
      d="M6 8V5.01H5V4h1v.5c.22-.18.687-.5 1-.5h2v1H7.65c-.213 0-.373.07-.48.21a.708.708 0 0 0-.17.41V8h1v1H5V8h1ZM13.95 9a.659.659 0 0 1-.29-.08.818.818 0 0 1-.26-.22.73.73 0 0 1-.61.3h-1.34c-.507 0-.877-.1-1.11-.3-.227-.207-.34-.557-.34-1.05v-.1C10 6.517 10.487 6 11.46 6H13v-.35c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17H10.5V4h1.8c.58 0 1.007.127 1.28.38.28.253.42.66.42 1.22V8c0 .1.037.177.11.23.08.047.21.07.39.07V9h-.55Zm-1.41-1c.2 0 .327-.047.38-.14A.72.72 0 0 0 13 7.5V7h-1.4a.583.583 0 0 0-.6.6v-.1c0 .173.04.3.12.38.08.08.207.12.38.12h1.04ZM16 8V5.01h-1V4h1v.5c.22-.18.687-.5 1-.5h2v1h-1.35c-.213 0-.373.07-.48.21a.708.708 0 0 0-.17.41V8h1v1h-3V8h1Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconRarSizeS;
